import Prospects from "@/pages/mlo/Prospects";
export default function Leads() {
  return <Prospects leadsOnly />;
}
